<div
  class="gold-upgrade-container horizontal-center focusable-container generic-dialog back-btn"
  (click)="disabled($event)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <app-generic-aha-gold-left-panel></app-generic-aha-gold-left-panel>
  <app-generic-aha-gold-right-panel
    [labelData]="label"
    [isBackPressed]="isBackPressed"
    [redirectFrom]="redirectFrom"
    [selectedIndex]="selectedIndex"
  ></app-generic-aha-gold-right-panel>
</div>
